import { elementReady, getAllCookies } from 'theme-utilities';
import { onFormSubmit } from './modules/submit';

elementReady('.hs_form form').then((form) => {
	if (form instanceof NodeList) {
		form.forEach((f) => {
			init(f);
		});
	} else {
		init(form);
	}
});

const init = (form) => {
	const cookies = getAllCookies();
	const gaField = form.querySelector('input[name="ga_client_id"]');
	if (gaField && cookies['_ga']) {
		gaField.value = cookies['_ga'];
	}

	form.addEventListener('submit', (event) => {
		// Prevent default event (redirect to action)
		event.preventDefault();

		// Run submit action
		onFormSubmit(form, event);
	});
};
